var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRwAutomation = function SvgRwAutomation(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_330_19128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0007 11.95C19.0007 12.9 18.8107 13.8 18.4707 14.63L21.0807 16.14C21.6707 14.87 22.0107 13.45 22.0107 11.96C22.0107 10.55 21.7207 9.22 21.1907 8L18.5607 9.52C18.8407 10.28 19.0107 11.1 19.0107 11.96L19.0007 11.95Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0801 18.8601V21.8901C15.9401 21.5801 18.4401 20.0601 20.0601 17.8601L17.4501 16.3501C16.3801 17.6701 14.8401 18.5901 13.0901 18.8601H13.0801Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6001 7.75989L20.2101 6.24989C18.6001 3.92989 16.5701 2.72989 14.9201 2.38989L13.3301 4.88989C15.1701 5.17989 16.5301 6.33989 17.6001 7.75989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0798 5.02V2C8.08984 2.27 5.47984 3.86 3.83984 6.19L6.44984 7.7C7.54984 6.27 9.19984 5.27 11.0798 5.03V5.02Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 11.9499C5 11.0599 5.17 10.2199 5.47 9.43993L2.85 7.92993C2.31 9.15993 2 10.5199 2 11.9599C2 13.4799 2.35 14.9199 2.96 16.2199L5.56 14.7199C5.2 13.8699 5 12.9399 5 11.9699V11.9499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61 16.3799L4 17.8899C5.21 19.5099 6.86 20.8699 8.86 21.4099L10.76 18.7999C9.1 18.4999 7.65 17.6299 6.62 16.3799H6.61Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 19.95C16.4183 19.95 20 16.3682 20 11.95C20 7.53167 16.4183 3.94995 12 3.94995C7.58172 3.94995 4 7.53167 4 11.95C4 16.3682 7.58172 19.95 12 19.95Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84028 21.4599L8.02028 21.1299L11.2403 14.0799H7.92028C7.09028 14.0799 7.61028 13.3699 7.63028 13.3399C9.54028 10.7799 11.6203 7.56988 14.5003 3.12988H15.4503L12.7703 10.2299H16.1003C16.4803 10.2299 16.6903 10.4099 16.4803 10.8599C11.8203 17.3399 8.84028 21.4699 8.84028 21.4699V21.4599Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_330_19128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.89,
    fill: "white",
    transform: "translate(2 2)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRwAutomation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "rw-automation.13038b07dc426e1a37ac3e6b0f9b227f.svg";